import { ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { isEmptyError } from '@shared/utils/empty-error';

/** Angular wraps a rejected promise in `{rejection}` and some errors in `{originalError}` / `{error}`. */
function unwrap(error: unknown): unknown[] {
    const wrapper = error as { rejection?: unknown; originalError?: unknown; error?: unknown } | null | undefined;
    if (typeof wrapper !== 'object' || wrapper === null) {
        return [error];
    }
    return [error, wrapper.rejection, wrapper.originalError, wrapper.error];
}

/**
 * Sentry's Angular ErrorHandler, minus the EmptyError the HTTP interceptor already handled
 * (UNIVAPLAT-3639). Every other error goes to Sentry unchanged.
 */
export function createAppErrorHandler(): ErrorHandler {
    const sentryHandler = Sentry.createErrorHandler();
    return {
        handleError(error: unknown): void {
            if (unwrap(error).some(isEmptyError)) {
                return;
            }
            sentryHandler.handleError(error);
        },
    };
}
